'use client'

import styles from './Editoras.module.css'
import editoras from '../../jsons/Editoras.json';

const Editoras = () => {
    return (
        <section className={styles.editoras} aria-label="Editoras parceiras do acervo">
            <div className="uiContainer">
                <h2 className={styles.title} tabIndex={0}>Nosso acervo é composto por mais de 80 editoras parceiras</h2>
                <ul className={styles.containerLogos} aria-label="Lista de editoras parceiras">
                    {editoras.map((editora, index) => (
                        <li key={index} className={styles.itemLogo}>
                            <img
                                src={editora.src}
                                alt={editora.alt}
                                loading="lazy"
                                width={117}
                                height={85}
                                tabIndex={0}
                            />
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    )
}

export default Editoras